<mat-select [value]="displayFontName"
            (selectionChange)="setFontName($event.value)"
            [ngStyle]="selectedFontStyle"
            placeholder="{{ 'i18n.control.fontChooser.placeholderText' |
                            translate }}"
>
  <mat-option *ngFor="let font of availableFonts"
              [value]="font"
              [ngStyle]="fontPreviewBackground(font)"
  >
    <span class="hidden">{{font}}</span>
  </mat-option>
</mat-select>



// WEBPACK FOOTER //
// ./src/app/controls/font-chooser/font-chooser.component.html